module.exports = __webpack_public_path__ + "static/media/email_inactive.55267f28.png";